/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Pack_OpenerInputs */



/**
* | output |
* | --- |
* | "Pack opener" |
*
* @param {Nav_Pack_OpenerInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const nav_pack_opener = /** @type {((inputs?: Nav_Pack_OpenerInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Pack_OpenerInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Pack-Öffner")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvreur de boosters")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("开包模拟")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("開包模擬")
	if (locale === "ko") return /** @type {LocalizedString} */ ("팩 개봉")
	return /** @type {LocalizedString} */ ("Pack opener")
});